module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('pl-dialog', {
    attrs: {
      "size": "relative",
      "title": _vm.isToEditSubmission ? 'Update Suggestion' : 'Add Suggestion',
      "disableOutsideClick": true
    },
    on: {
      "close": function($event) {
        return _vm.$emit('close')
      }
    }
  }, [(_vm.isToEditSubmission === false) ? _c('div', {
    staticClass: "flex justify-center"
  }, [_c('div', {
    staticClass: "flex justify-center mt-10 mb-4"
  }, [_c('i', {
    staticClass: "fa-solid fa-circle-plus text-4xl text-primary"
  })])]) : _vm._e(), _vm._v(" "), (_vm.isToEditSubmission === false) ? _c('p', {
    staticClass: "text-center px-32 text-gray-800 mb-5"
  }, [_vm._v("\n    After adding new suggestion you can use on all students or import later to\n    another course.\n  ")]) : _vm._e(), _vm._v(" "), _c('textarea', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.suggestion),
      expression: "suggestion"
    }],
    staticClass: "bg-gray-100 rounded mx-6 outline-none px-6 py-4",
    class: _vm.isToEditSubmission === true ? 'mt-6' : '',
    attrs: {
      "rows": _vm.isToEditSubmission === true ? 11 : 6,
      "placeholder": "Write a new Suggestion"
    },
    domProps: {
      "value": (_vm.suggestion)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.suggestion = $event.target.value
      }
    }
  }), _vm._v(" "), (_vm.isToEditSubmission) ? _c('div', {
    staticClass: "flex justify-center items-center mt-6 mx-6"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.isToApplySuggestion),
      expression: "isToApplySuggestion"
    }],
    staticClass: "cursor-pointer",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.isToApplySuggestion) ? _vm._i(_vm.isToApplySuggestion, null) > -1 : (_vm.isToApplySuggestion)
    },
    on: {
      "change": function($event) {
        var $$a = _vm.isToApplySuggestion,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.isToApplySuggestion = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.isToApplySuggestion = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.isToApplySuggestion = $$c
        }
      }
    }
  }), _vm._v(" "), _c('span', {
    staticClass: "ml-2 text-sm"
  }, [_vm._v("Apply sugestion after update")])]) : _vm._e(), _vm._v(" "), _c('div', {
    staticClass: "flex justify-center my-6"
  }, [_c('button', {
    staticClass: "bg-gray-100 rounded px-5 py-2 mr-3",
    on: {
      "click": function($event) {
        return _vm.$emit('openMySuggestionsModal')
      }
    }
  }, [_vm._v("\n      Cancel\n    ")]), _vm._v(" "), _c('button', {
    attrs: {
      "\class": "sample px-5 py-2 bg-primary rounded text-white"
    },
    on: {
      "click": function($event) {
        _vm.isToEditSubmission === true ? _vm.editSuggestion() : _vm.createSuggestion()
      }
    }
  }, [_vm._v("\n      " + _vm._s(_vm.isToEditSubmission === true ? 'Update Suggestion' : 'Add Suggestion') + "\n    ")])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler.js?id=data-v-0f21c0fe!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/app/features/liveDiscussion/components/Participants/NewSuggestionFeedback.vue
// module id = 1849
// module chunks = 61